import React, { useEffect, useState } from 'react'; 
import { FixedBottomBar, HeaderBox } from './MobileBookPage';
import { Box, IconButton, Typography, Grid, Paper, Avatar } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import GeetGovindServices from "../../Services/GeetGovind";
import KalyansServices from "../../Services/Kalyan";
import KalpataruServices from '../../Services/Kalpataru';
import VivekService from '../../Services/Vivekvani';
export enum Product {
    Book = 1,
    Audio = 2,
    Pravachan = 4,
    Article = 3,
    Kalyan = 5,
    KalyanKalpataru = 6,
    MonthlyMagazine = 7,
    VivekVani = 8,
    Video = 9,
    DailySatsang = 10
}
const MobileMagazines = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const fixedBottomBarHeight = 56;

    // Use state to store the magazines data
    const [magazines, setMagazines] = useState<any>([]);
    const [totalMagazines, setTotalMagazines] = useState(0); // State for total magazines
    const [magazineData, setMagazineData] = useState(null);
    const [kalyanData, setKalyanData] = useState(null);
    const [kalpataruData, setKalpataruData] = useState(null);
    const [vaniData, setVaniData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [totalRecordsSum, setTotalRecordsSum] = useState(0);
    const [magazineId, setMagazineId] = useState<any>({});
    const [magId, setMagId] = useState<any>();
    const [showAll, setShowAll] = useState(false);
    useEffect(() => {
        const fetchMagazines = async () => {
            try {
                // Assuming GeetGovindServices.getAllMagazines() is your API call
                const response = await GeetGovindServices.getAllMagazines();
                if (response.status && response.result && response.result.items) {
                    setMagazines(response.result.items);
                    setTotalMagazines(response.result.totalRecords); // Set total records
                } else {
                    console.error("Failed to fetch magazines:", response.message);
                }
            } catch (error) {
                console.error("Error fetching magazines:", error);
            }
        };

        fetchMagazines();
    }, []);

    useEffect(() => {
        const fetchAndSumRecords = async () => {
            setLoading(true);
            setError(null);
            let sumOfTotals = 0;
            try {
                const currentLang = localStorage.getItem("lan") || "en";
                const commonParams = {
                    start: 0,
                    length: 67,
                    categoryId: "",
                    IsChildLiterature: false,
                    sort: "",
                    authorId: "",
                    search: "",
                    isSpecial: false,
                };
                const [
                    monthlyMagazineResponse,
                    kalyansResponse,
                    kalpataruResponse,
                    vaniResponse,
                ] = await Promise.all([
                    GeetGovindServices.getMonthlyMagazine(
                        commonParams.search, commonParams.start, commonParams.length,
                        commonParams.categoryId, commonParams.IsChildLiterature, commonParams.sort,
                        commonParams.authorId, "", commonParams.isSpecial, "", ""
                    ),
                    KalyansServices.getKalyans(
                        commonParams.start, commonParams.length, commonParams.IsChildLiterature,
                        commonParams.categoryId, commonParams.authorId, commonParams.search,
                        commonParams.sort, "", commonParams.isSpecial
                    ),
                    KalpataruServices.getKalyansKalpataru(
                        commonParams.start, commonParams.length, commonParams.IsChildLiterature,
                        commonParams.categoryId, commonParams.authorId, commonParams.search,
                        commonParams.sort, "", commonParams.isSpecial
                    ),
                    VivekService.getVanis(
                        commonParams.start, commonParams.length, commonParams.categoryId,
                        commonParams.IsChildLiterature, commonParams.sort, commonParams.authorId,
                        commonParams.search, "", commonParams.isSpecial
                    ),
                ]);
                const mmTotal = monthlyMagazineResponse?.result?.totalRecords || 0;
                const kalyanTotal = kalyansResponse?.result?.totalRecords || 0;
                const kalpataruTotal = kalpataruResponse?.result?.totalRecords || 0;
                const vaniTotal = vaniResponse?.result?.totalRecords || 0;

                sumOfTotals += Number(mmTotal);
                sumOfTotals += Number(kalyanTotal);
                sumOfTotals += Number(kalpataruTotal);
                sumOfTotals += Number(vaniTotal);
                setTotalRecordsSum(sumOfTotals);
                setMagazineId({
                    monthlyMagazine: monthlyMagazineResponse?.result?.id,
                    kalyans: kalyansResponse?.result?.id,
                    kalpataru: kalpataruResponse?.result?.id,
                    vani: vaniResponse?.result?.id,
                });

                setMagId(monthlyMagazineResponse?.result?.items)
                console.log(monthlyMagazineResponse, "monthl")

            } catch (err: any) {
                setError(err.message || "An unknown error occurred while fetching data.");
                console.error("Caught error during data fetching:", err);
            } finally {
                setLoading(false);
                console.log("Data fetching process completed.");
            }
        };
        fetchAndSumRecords();
    }, []);


    const handleMagazineClick = (productType: any, magazineName: string, magazineLanguage: any, magzineId: string, magazineSlug?: string) => {
        switch (productType) {
            case Product.MonthlyMagazine:
                navigate('/magazines/geetgovind', { state: { productType, magazineLanguage: magazineLanguage, magzineId: magzineId } });
                break;
            case Product.Kalyan:
                navigate('/magazines/kalyan', { state: { productId: productType, magazineLanguage: magazineLanguage, magzineId: magzineId } })
                break;
            case Product.KalyanKalpataru:
                navigate('/magazines/kalyanakalpataru', { state: { productId: productType, magazineLanguage: magazineLanguage, magzineId: magzineId } })
                break;
            case Product.VivekVani:
                navigate('/magazines/vivekvani', { state: { vivekVaniId: productType, magazineLanguage: magazineLanguage, magzineId: magzineId } })
                break;
            default:
                break;
        }
    };
    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
                <HeaderBox>
                    <>
                        <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}>
                            <ArrowBackIosIcon sx={{ color: "white", fontSize: '18px' }} />
                        </IconButton>
                        <IconButton onClick={() => navigate("/")} sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}>
                            <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
                        </IconButton>
                        <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
                            {t("shrihari_tr")}
                        </Typography>
                        <Typography variant="h6" sx={{ color: "#ffffffdd", opacity: 0.9, fontSize: 15 }}>
                            {t("magazine_tr")}
                        </Typography>
                    </>
                </HeaderBox>
                <div style={{ width: "100%", backgroundColor: "whitesmoke", textAlign: 'center', position: 'fixed', top: 90, zIndex: 1200, padding: '1px 0', }}>
                    {t("Total_Magazines_tr")} : {totalRecordsSum}
                </div>
                <Box
                    sx={{
                        msOverflowStyle: 'none',
                        scrollbarWidth: 'none',
                        flexGrow: 1,
                        overflowY: 'auto',
                        pb: `${fixedBottomBarHeight}px`,
                        backgroundColor: "whitesmoke",
                        mt: '10px'
                    }}
                    role="presentation"
                >
                    {/* //content */}
                    <Grid container spacing={1} sx={{ paddingRight: 1, paddingLeft: 1, paddingTop: 2 }}>
                        {magazines?.slice(0, showAll ? magazines.length : 10)?.map((magazine: any) => (

                            <Grid item xs={6} key={magazine.id}>
                                <Paper
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        p: 1,
                                        height: '100%',
                                        textAlign: 'center',
                                        boxShadow: 'none',
                                    }}
                                    onClick={() => { handleMagazineClick(magazine?.productType ?? magazine?.productId, magazine.name, magazine.magazineLangauge, magazine.id, magazine.slug) }}
                                >
                                    <img
                                        className='mt-1'
                                        src={magazine.coverPagePath} // Use coverPagePath from API response
                                        alt={magazine.name}
                                        style={{ width: '70%', height: 'auto', maxWidth: '150px', borderRadius: '4px' }}
                                    />
                                    <Typography variant='body2' sx={{ mt: 1, fontSize: 16, fontFamily: 'chanakyaUni', color: '#C6011F', fontWeight: 500 }}>
                                        {magazine.name}
                                    </Typography>
                                </Paper>
                            </Grid>
                        ))}
                        {!showAll && magazines?.length > 10 && (
                            <Grid item xs={6}>
                                <Paper
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        p: 1,
                                        height: '100%',
                                        textAlign: 'center',
                                        boxShadow: 'none',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => setShowAll(true)}
                                >
                                    <Avatar sx={{ bgcolor: '#f97316', width: 35, height: 35 }}>
                                        <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
                                    </Avatar>
                                    <Typography variant='body2' sx={{ mt: 1, fontSize: 14, color: '#f97316', fontWeight: 500 }}>
                                        {t('view_all_tr')} {totalMagazines}
                                    </Typography>
                                </Paper>
                            </Grid>
                        )}
                    </Grid>
                </Box>
                {/* <FixedBottomBar sx={{ zIndex: 1300 }} /> */}
            </Box>
        </>
    );
};

export default MobileMagazines;